export default __webpack_public_path__ + "static/media/ruby.6cc81011.svg";